import SecondaryTabsMenuView from './secondary_tabs_menu_view';

export default SecondaryTabsMenuView;
